<template>
  <div class="container" ref="container">
    <div class="list" v-if="refundList.length > 0">
      <div class="item" v-for="(item, index) in refundList" :key="index">
        <div class="order-no">订单编号：{{ item.order_order_id }}</div>
        <div class="order-no">售后编号：{{ item.order_return_sn }}</div>
        <RefundGoodsItem
          :cart-info="item"
          :show-number="false"
        ></RefundGoodsItem>
        <div class="status">
          <template v-if="item.type == 1">
            <img src="@images/refund_status_1.png" alt="" />
            <span>仅退款</span>
          </template>
          <template v-else-if="item.type == 2">
            <img src="@images/refund_status_2.png" alt="" />
            <span>退货退款</span>
          </template>
          <template v-if="item.type == 3">
            <img src="@images/refund_status_3.png" alt="" />
            <span>换货</span>
          </template>
          &nbsp;
          <span>{{ getStatus(item) }}</span>
        </div>
        <div class="action">
          <!--                    取消后，完成后，审核不通过才能删除-->
          <!--<div
            class="btn delete"
            v-if="item.status == 6 || item.status == 7 || item.status == 8"
            @click.stop="deleteOrder(item.id)"
          >
            删除订单
          </div>-->
          <div class="btn info" @click="toDetail(item.id)">查看详情</div>
        </div>
      </div>
    </div>
    <div class="noCart" v-if="refundList.length === 0">
      <div class="pictrue"><img src="@assets/images/noOrder.png" /></div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>

<script>
const STATUS = [
  "申请中",
  "待退款",
  "等待买家退货",
  "已收货未退款",
  "已收货未重新发货",
  "已重新发货",
  "审核不通过",
  "取消申请",
  "完成售后"
];
import RefundGoodsItem from "@components/RefundGoodsItem";
import Loading from "@components/Loading";
import { getOrderReturnList, delOrderReturn } from "@api/user";
export default {
  name: "AfterSaleList",
  components: {
    RefundGoodsItem,
    Loading
  },
  data() {
    return {
      refundList: [],
      page: 1,
      limit: 20,
      loaded: false,
      loading: false
    };
  },
  // watch:{
  //     '$router':function(){
  //         this.page=1
  //         this.limit=20
  //         this.loaded=false
  //         this.loading=false
  //         this.refundList = []
  //         this.$nextTick(()=>{
  //             this.getRefundList()
  //         })
  //     }
  // },
  mounted() {
    console.log("mounted");
    this.page = 1;
    this.limit = 20;
    this.loaded = false;
    this.loading = false;
    this.refundList = [];
    this.$nextTick(() => {
      this.getRefundList();
    });

    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getRefundList();
    });
  },
  methods: {
    getStatus(item) {
      if (item.status != 8) {
        return STATUS[item.status];
      } else {
        if (item.type != 3) {
          return "退款成功";
        } else {
          return "换货成功";
        }
      }
    },
    /**
     * 获取售后列表
     */
    getRefundList() {
      if (this.loaded || this.loading) {
        return false;
      }
      getOrderReturnList({ page: this.page, limit: this.limit }).then(res => {
        console.log(res);
        this.refundList.push(...res.data.data);
        this.page++;
        this.loaded = res.data.data.length < this.limit;
        this.loading = false;
      });
    },
    /**
     * 跳转售后详情页
     */
    toDetail(id) {
      this.$router.push("/user/refund_detail?id=" + id);
    },
    /**
     * 删除售后订单
     */
    deleteOrder(id) {
      this.$dialog.confirm({
        mes: "确认删除?",
        opts: () => {
          delOrderReturn({ id: id })
            .then(() => {
              this.$dialog.toast({ mes: "删除成功" });
              setTimeout(() => {
                window.location.reload();
              });
            })
            .catch(err => {
              this.$dialog.error(err.msg);
            });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  padding: 0.2rem;
  background-color: #f0f0f0;
  height: 100%;
  .list {
    .item {
      background-color: #fff;
      padding: 0.24rem 0.2rem;
      border-radius: 0.16rem;
      margin-top: 0.2rem;
      &:first-of-type {
        margin-top: 0;
      }
      .order-no {
        color: #333;
        font-size: 0.28rem;
        font-weight: 400;
        margin-bottom: 0.2rem;
      }

      .status {
        padding: 0.2rem 0;
        border-bottom: 1px solid #f0f0f0;
        font-size: 0.24rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        span {
          margin-left: 0.1rem;
          color: #666;
        }
        img {
          width: 0.32rem;
          height: 0.32rem;
        }
      }
      .action {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        margin-top: 0.2rem;
        .btn {
          min-width: 1.52rem;
          height: 0.6rem;
          border-radius: 0.32rem;
          font-size: 0.28rem;
          margin-left: 0.2rem;
          display: flex;
          justify-content: center;
          align-items: center;
          &.delete {
            color: #666;
            border: 1px solid #ccc;
          }
          &.info {
            color: #ec5d59;
            border: 1px solid #ec5d59;
          }
        }
      }
    }
  }
  .noCart {
    height: 100%;
    margin-top: 0.17rem;
    padding-top: 0.1rem;
    .pictrue {
      width: 4rem;
      height: 3rem;
      margin: 0.7rem auto 0.5rem auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
